export const fullReload = () => window.location.reload()
